import BaseApi from './base.api';
import ApiService from '@services/api.service';

export default {
    ...BaseApi,
    ...{
        resource: 'fee-type-details'
    },
    getRegistrationAmount(params = null) {
        return ApiService.get(`/getRegistrationAmount`, params);
    },

    getClothesTypes(params = null) {
        return ApiService.get(`/${this.resource}/get/clothes/types`, params);
    },
    printExtensiveCourseLetter(params = null) {
        return ApiService.post(`/${this.resource}/extensive-course-request`, params);
    },
    printInvoiceLetter(params = null) {
        return ApiService.post(`/${this.resource}/invoice-letter`, params);
    },
    printInvoiceLetter2025(params = null) {
        return ApiService.post(`/${this.resource}/invoice-letter-2025`, params);
    },
    printAcknowledgment(params = null) {
        return ApiService.post(`/${this.resource}/print-acknowledgment`, params);
    },
}
